var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComissoesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#2BAE8B",
    width: "800px",
    height: "800px",
    viewBox: "-1.7 0 20.4 20.4",
    xmlns: "http://www.w3.org/2000/svg",
    className: "cf-icon-svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.417 10.283A7.917 7.917 0 1 1 8.5 2.366a7.916 7.916 0 0 1 7.917 7.917zM5.909 9.536a1.812 1.812 0 1 0-1.812-1.813 1.814 1.814 0 0 0 1.812 1.813zm0-1.109a.704.704 0 1 1 .704-.704.705.705 0 0 1-.704.704zm5.72-1.402a.792.792 0 1 0-1.316-.88l-4.924 7.372a.792.792 0 0 0 1.317.88zm1.286 5.837a1.812 1.812 0 1 0-1.812 1.812 1.814 1.814 0 0 0 1.812-1.812zm-1.109 0a.704.704 0 1 1-.703-.704.705.705 0 0 1 .703.704z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComissoesIcon);
export default __webpack_public_path__ + "static/media/comissoesIcon.2549f088081b9fe273a27c8f29ecf9cd.svg";
export { ForwardRef as ReactComponent };